import { SecureContentsId } from 'shared-client/secure-contents-id';
import { decryptContents } from 'shared-client/crypto';
import { deSerDEK } from 'shared-client/serde';
import { fromHex } from 'shared-client/util';

export type DownloadInput = {
  blob: Blob;
  contentType: string;
  fileName: string;
};

export class SecureContents {
  constructor(
    readonly secureContentsId: SecureContentsId,
    readonly dek: CryptoKey,
  ) {}

  async download({ blob, fileName, contentType }: DownloadInput): Promise<File> {
    const buffer = await blob.arrayBuffer();
    const decryptedBlob = await decryptContents(this.dek, buffer);
    return new File([decryptedBlob], fileName, { type: contentType });
  }

  static async fromEncrypted(
    secureContentsId: SecureContentsId,
    encryptedDek: string,
  ) {
    const dekdek = await secureContentsId.getDEK();
    const decryptedDekDek = await decryptContents(
      dekdek,
      fromHex(encryptedDek),
    );
    const fileDek = await deSerDEK(decryptedDekDek);
    return new SecureContents(secureContentsId, fileDek);
  }
}
